import React, { useRef } from "react";
import { Icon, chakra } from "@chakra-ui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useButton } from "react-aria";
export default function ClearSelectButton({ onClick }) {
    const ref = useRef(null);
    const { buttonProps } = useButton({
        children: "Clear selection",
        elementType: "span",
        onPress: onClick,
    }, ref);
    return (React.createElement(chakra.span, { ref: ref, boxSize: 4, display: "flex", outline: "none", borderRadius: "base", _focusVisible: {
            boxShadow: "outlineGreen",
        }, ...buttonProps },
        React.createElement(Icon, { as: XMarkIcon, boxSize: 4, flex: "none" })));
}
